import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://tzaxkiiohwxcuclfryru.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_pNKPlnhllScFgXV3_dA-LA_u5NjNqbT';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);